export default {
  title: "",
  subtitle: "",
  path: "bank_transactions_list",
  paragraph: "Returns the transactions associated to an specific bank transfer.",
  request: {
      method: "GET",
      endpoint: "/wires/:id/transactions",
      responses: {
      "data": [
        {
            "value": "100.00",
            "to_bank_account_id": "102518ca-5d8a-443f-b131-e47d99bc4d0d",
            "subject_is_receiver": true,
            "subject_id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
            "subject": {
                "updated_at": "2025-07-09T17:41:45.594060",
                "status": "approved",
                "social_name": "John Doe",
                "rfc_pf": null,
                "required_clearance_level": 2,
                "phone_number": "99812-1212",
                "phone_country_code": "55",
                "phone_area_code": "18",
                "net_monthly_average_income": "4000.00",
                "inserted_at": "2021-03-11T20:13:17.729215",
                "id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
                "fiscal_country": "BR",
                "email": "joaquim@email.com",
                "document_type": "cpf",
                "document_number": "05069869183",
                "clearance_level": 2,
                "birth_date": "2015-04-01",
                "address_street": "Rua Barão do Rio Branco",
                "address_state": "SP",
                "address_postal_code": "16201220",
                "address_number": "310",
                "address_neighborhood": null,
                "address_country": "BR",
                "address_complement": "Apt. 44 A",
                "address_city": "Birigui"
            },
            "status": "wired",
            "source_name": "John Doe",
            "source_document_type": "cpf",
            "source_document_number": "05069869183",
            "meta": null,
            "inserted_at": "2025-01-22T13:31:19.095744",
            "id": "8a4babe5-6ba9-424b-a665-e61fecc3af0a",
            "from_credit_card_id": null,
            "from_bank_account_id": "6b1d3acf-42b7-4f5a-8d9b-1da2766e040b",
            "for_exchange": true,
            "exchanged_value": "574.84",
            "exchange_under_request": false,
            "exchange_currency": "BRL",
            "estimated_value_until_exchange": false,
            "currency": "USD",
            "cleared": true,
            "bank_transaction": {
                "wire_id": "e027fc20-42d0-4da6-92d8-60893509b531",
                "value": "100.0",
                "spei_reference": null,
                "spei_concepto_de_pago": "8a4babe5-6ba9-424b-a665-e61fecc3af0a",
                "source_type": "TED-PRE",
                "source_name": "John Doe",
                "source_id": "8a4babe5-6ba9-424b-a665-e61fecc3af0a",
                "source_document_type": "cpf",
                "source_document_number": "05069869183",
                "source_description": "CREDITO POR TED ANTECIPADO",
                "source_branch": null,
                "source_bank_ispb": null,
                "source_bank": null,
                "source_account": null,
                "movement_date": "2025-02-05",
                "iof_value": "2.21",
                "inserted_at": "2025-02-05T16:25:06.669334",
                "id": "8afb46a6-2d9a-46f7-8630-ed1c6f0cf1c2",
                "exchanged_value": "574.84",
                "exchange_rate_spot": "5.82864000",
                "exchange_rate": "5.74843",
                "exchange_id": "f73b074e-8139-4606-b178-bf209bbca83c",
                "exchange_currency": "BRL",
                "exchange_approved": true,
                "currency": "USD"
            }
        }
    ]
  }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Customer UUID"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/BankTransfersTransactionsList.js